import { DatatableConfig } from 'src/app/config/DatatableConfig';
import { ISiglaAsignatura, ISedes } from 'src/app/interfaces/exclusion-asignatura';
import { IDocentesID, IListaReporteCalificaciones, IListaReporteCalificacionesRes, IObtenerFiltros } from 'src/app/interfaces/notas-parciales';
import { FormControl, FormBuilder, Validators } from '@angular/forms';
import { Observable, startWith, map, debounceTime, distinctUntilChanged } from 'rxjs';
import { IListaAnhos } from 'src/app/interfaces/ponderaciones';
import { Router } from '@angular/router';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { PonderacionesService } from 'src/app/services/ponderaciones/ponderaciones.service';
import { Component, OnInit } from '@angular/core';
import { NotasParcialesService } from 'src/app/services/notas-parciales/notas-parciales.service';
import { saveAs } from 'file-saver';
import { UtilsFnService } from 'src/app/services/utils/utils-fn.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-view-reporte-notas-parciales',
  templateUrl: './view-reporte-notas-parciales.component.html',
  styleUrls: ['./view-reporte-notas-parciales.component.scss']
})
export class ViewReporteNotasParcialesComponent implements OnInit {


  dtOptions: DataTables.Settings = { ...DatatableConfig.dtOptionDefaultSearchLeft }
  renderTable: boolean = true
  filtroAnhoSeleccionado: number = 0
  configFiltrosAnterior: any = null
  filtroAnhos: Array<number> = []
  filtroPeriodoSeleccionado: number = 0
  filtroAsignaturaSeleccionado: number | '' = ''
  filtroSedeSeleccionado: number = 0
  filtroPeriodos: Array<any> = []
  filtroAsignaturas: Array<any> = []
  filteredAsignatura: Observable<Array<any>>
  searchAsignaturaForm = new FormControl('')
  listaAsignatura: any = []
  tieneErrores: any = {}
  submitted: boolean = false;
  listaSedes: any = []
  rolUsuario: number | null = null;
  filtrosSede: Array<any> = []
  errorRut: string = ''
  resaltarError: boolean = true
  rut: string = ''
  searchIdDocenteForm = new FormControl('')
  mensajeExito: string = "";
  error: string = "";
  listaIdDocentes: any = []
  filteredDocenteId: Observable<Array<any>>
  filtroCodigoDocenteSeleccionado: string = ""
  asignaturaCodigo: string = ''
  errorRutAlumno: string = ""
  infoModalTitulo: string = ''
  infoModalTexto: string = ''
  listaReporteCalificaciones: Array<any> = []
  detalleFiltros: any = {}
  detalleFiltrosEsp : any = {}
  funcionIntervalo: any;
  reporteEnProceso: boolean = false;

  cargaInicial: boolean = true

  parametrosForm = this.formBuilder.group({
    anyo: ['0', [Validators.required]],
    periodo: ['0', [Validators.required]],
    sede: ['0'],
    asignatura: [''],
    rut: [''],
    docenteId: ['']
  })

  constructor(
    private _ponderaciones: PonderacionesService,
    private _perfilamiento: PerfilamientoService,
    private _notasParciales: NotasParcialesService,
    private router: Router,
    private formBuilder: FormBuilder,
    private _utilsFn: UtilsFnService,
    private spinner: NgxSpinnerService
  ) {
    const routerData = this.router.getCurrentNavigation()?.extras?.state?.['data']
    if (routerData?.configuracion) {
      this.filtroAnhoSeleccionado = routerData.configuracion.anyo
    }
    this.filteredAsignatura = this.searchAsignaturaForm.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', "asignatura")),
    );

    this.filteredDocenteId = this.searchIdDocenteForm.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', "docente")),
    );

    this.searchAsignaturaForm.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged()
    )
      .subscribe(res => {
        this.filtroCodigoDocenteSeleccionado = "";
        this.listaIdDocentes = [];
        this.searchIdDocenteForm.setValue("")
        if (typeof res === 'object') {
          this.listaIdDocentes = []
          let id = this.obtenerId(res)
          this.filtroAsignaturaSeleccionado = id
          this.getIdDocente()
        } else {
          this.filtroAsignaturaSeleccionado = 0;
          if (res == ""){
            this.getIdDocente()
          }
        }
      })

    this.searchIdDocenteForm.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged()
    )
      .subscribe(res => {
        if (typeof res === 'object') {
          let codigo = this.obtenerCodigoDocente(res);
          this.filtroCodigoDocenteSeleccionado = codigo;
        } else {
          this.filtroCodigoDocenteSeleccionado = "";
        }

      })

    let user = this._perfilamiento.getUsuario();
    this.rolUsuario = user.rolId;
  }

  ngOnInit(): void {
    this.getAnhos()
    this.dtOptions = { ...DatatableConfig.dtOptionDefaultSearchLeftDesc }
    this.dtOptions.lengthMenu = [10, 20, 30, 40, 50];
    this.actualizarTabla()
  }

  obtenerCodigoDocente(objeto: any): string {
    return objeto.codigo;
  }
  private _filter(value: string, solicitante: string) {
    if (typeof value != 'string') {
      return [];
    }
    const filterValue = this._normalizeValue(value);
    if (solicitante == "asignatura") {
      return this.listaAsignatura.filter((asignatura: { id: number, codigo: string }) => this._normalizeValue(asignatura?.codigo)?.includes(filterValue));
    } else {
      return this.listaIdDocentes.filter((docente: { docenteId: number, codigo: string }) => this._normalizeValue(docente?.codigo)?.includes(filterValue))
    }
  }
  private _normalizeValue(value: string): string {
    return value?.toLowerCase()?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, '');
  }

  obtenerId(objeto: any): number {
    if (objeto.id) {
      return objeto.id;
    } else {
      return objeto.docenteId
    }
  }
  obtenerSede(sede:any):number{
    return sede.sedeId
  }
  obtenerAsignaturaCodigo(objeto: any): string {
    return objeto.codigo
  }

  displayFnAsignatura(asignatura: any): string {
    return asignatura?.codigo ? asignatura.codigo.replace(/\w\S*/g, (w: string) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '';
  }

  displayFnIdDocente(idDocente: any): string {
    return idDocente?.codigo ? idDocente.codigo.replace(/\w\S*/g, (w: string) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '';
  }
  getAnhos() {
    this._ponderaciones.getFiltrosAnhos().subscribe(
      (res: IListaAnhos) => {
        this.filtroAnhos = res.anyos

        if (this.configFiltrosAnterior) {
          this.seleccionFiltro("anyo");
        } else {
          this.getPeriodos();
        }
      }, (err: any) => {
      }
    )
  }

  getPeriodos() {
    this._ponderaciones.getFiltrosPeriodos(Number(this.filtroAnhoSeleccionado)).subscribe(
      (res: any) => {
        this.filtroPeriodos = res.periodos

        if (this.configFiltrosAnterior) {
          this.filtroPeriodoSeleccionado = this.configFiltrosAnterior.periodoId;
          this.seleccionFiltro("periodos")
        }
      }
    )
  }

  resetearValidacion() {
    this.submitted = false;
    this.tieneErrores["anyo"] = false;
    this.tieneErrores["periodo"] = false;
    this.tieneErrores["sede"] = false;
    this.tieneErrores["tipoAsignatura"] = false;
    this.tieneErrores["asignatura"] = false;
  }


  getListaSiglaAsignatura() {
    if (this.filtroAnhoSeleccionado != 0 && this.filtroPeriodoSeleccionado != 0) {
      this.searchAsignaturaForm.setValue("");
      this._notasParciales.getFiltrosAsignaturas({
        anyo: this.filtroAnhoSeleccionado,
        sedeId: this.filtroSedeSeleccionado,
        periodoId: this.filtroPeriodoSeleccionado,
      }).subscribe({
        next: (res: ISiglaAsignatura) => {
          this.listaAsignatura = res.asignaturas
        }
      })
    }

  }

  getListaSedes(anyo: number, periodoId: number): void {
    if (anyo != 0 && periodoId != 0) {
      this.filtroAsignaturaSeleccionado = 0
      this.listaSedes = []
      let user = this._perfilamiento.getUsuario();
      this._notasParciales.getFiltrosSedes(user.usuarioId).subscribe(
        (res: ISedes) => {
          this.listaSedes = res.sedes;
        }
      )
    }
  }



  getIdDocente(): void {
    if (this.filtroAnhoSeleccionado != 0 && this.filtroPeriodoSeleccionado != 0) {
      this._notasParciales.getListaIdDocentes(
        Number(this.filtroAnhoSeleccionado),
        Number(this.filtroPeriodoSeleccionado),
        Number(this.filtroAsignaturaSeleccionado),
        Number(this.filtroSedeSeleccionado)
      ).subscribe({
        next: (res: IDocentesID) => {
          this.listaIdDocentes = res.docentes
        }
      })
    }

  }

  seleccionFiltro(filtro: string = '') {
    switch (filtro) {
      case 'anho':
        this.getPeriodos()
        this.filtroPeriodoSeleccionado = 0
        this.filtroAsignaturaSeleccionado = ''
        this.filtroSedeSeleccionado = 0
        this.searchIdDocenteForm.setValue("")
        break;
      case 'periodo':
        // this.getListaSiglaAsignatura()
        this.filtroAsignaturaSeleccionado = ''
        this.filtroSedeSeleccionado = 0
        this.listaSedes = []
        if (this.rolUsuario === 1) {
          this.listaAsignatura = [];
          this.searchAsignaturaForm.setValue("")
          this.getListaSiglaAsignatura()
          this.listaIdDocentes = []
          this.searchIdDocenteForm.setValue("")
          // this.getIdDocente()
        }
        this.getListaSedes(Number(this.filtroAnhoSeleccionado),Number(this.filtroPeriodoSeleccionado))
        break;
        case 'sede':
        // this.getIdDocente()
        this.filtroAsignaturaSeleccionado = ''
        this.listaIdDocentes = []
        this.searchIdDocenteForm.setValue("")
        this.getListaSiglaAsignatura()
        this.getIdDocente()
        this.listaAsignatura = []
        this.searchAsignaturaForm.setValue("")
        break
      case 'asignatura':
        this.getListaSiglaAsignatura()
        break

      case 'docenteId':
        break;
    }
  }

  fnfiltroObligatorio(): boolean {
    let filtroObligatorioSinCompletar:boolean = false
    if (this.rolUsuario === 2 ) {
      if (this.filtroAnhoSeleccionado === 0 || this.filtroPeriodoSeleccionado === 0 || this.filtroSedeSeleccionado === 0 ) {
        filtroObligatorioSinCompletar = true
      }

    } 
    
    if (this.rolUsuario !== 2 && this.filtroAnhoSeleccionado === 0 || this.filtroPeriodoSeleccionado === 0 ) {
      filtroObligatorioSinCompletar = true
    }

    return filtroObligatorioSinCompletar
  }

  fnBodyReq(dataTable: any = null): any {
    return {
      anyo: this.filtroAnhoSeleccionado != 0 ? Number(this.filtroAnhoSeleccionado) : null,
      periodoId: this.filtroPeriodoSeleccionado != 0 ? Number(this.filtroPeriodoSeleccionado) : null,
      sedeId: this.filtroSedeSeleccionado != 0 ? Number(this.filtroSedeSeleccionado) : null,
      asignaturaId: this.filtroAsignaturaSeleccionado ? Number(this.filtroAsignaturaSeleccionado) : null,
      asignaturaCodigo: this.asignaturaCodigo != '' ? this.asignaturaCodigo : null,
      docenteId: this.filtroCodigoDocenteSeleccionado != "" ? this.filtroCodigoDocenteSeleccionado : null,
      rutEstudiante: this.rut !== '' ? this.rut : null,

      // Datatable params
      ...(dataTable?.search ? { search: dataTable.search } : {}),
      ...(dataTable?.pageSize ? { pageSize: dataTable.pageSize } : {}),
      ...(dataTable?.pageNumber ? { pageNo: dataTable.pageNumber } : {})
    }
  }

  generarSolicitudReporte(): void {
    const filtroObligatorioSinCompletar: boolean = this.fnfiltroObligatorio()
    if (!filtroObligatorioSinCompletar) {
      const body = this.fnBodyReq()
      this._notasParciales.generarReporte(body).subscribe({
        next: (res: IListaReporteCalificaciones) => {
          if (res.error != null) {
            this.errorRutAlumno = res.error.mensaje
            this.limpiarMensajes()
          } else {
            this.buscarReporte()
          }
        },
      }
      )
    }
  }

  reiniciarDt(idTabla: string, dtOptions: any): void {
    const $tabla = $(`#${idTabla}`);
    if ($.fn.dataTable.isDataTable($tabla)) {
      $(`#${idTabla}`).DataTable().destroy();
    }
    setTimeout(() => {
      if (!$.fn.dataTable.isDataTable($tabla)) {
        $(`#${idTabla}`).DataTable(dtOptions);
      }
    }, 350); 
  }

  buscarReporte(): void {
    this.reporteEnProceso = false
    if ( this.cargaInicial ) {
      this.spinner.show()
    }
    setTimeout(() => {
      if ( this.renderTable ) {
        this.renderTable = false;
        this.reiniciarDt('tabla-notas-parciales', this.dtOptions)
      }
      this.renderTable = true;

      // Datatable serverside
      this.dtOptions.serverSide = true
      this.dtOptions.pageLength = 10
      this.dtOptions.processing = true
      this.dtOptions.ajax = (dataTablesParameters: any, callback) => { 
        let paramsTableBody = {
          pageSize: dataTablesParameters.length,
          pageNumber: (dataTablesParameters.start / dataTablesParameters.length)+1
        }
        const busquedaTabla: string = dataTablesParameters.search.value
        this._utilsFn.agregarLoader('tabla-notas-parciales')
        const body = this.fnBodyReq({
          search: busquedaTabla,
          pageSize: paramsTableBody.pageSize,
          pageNumber: paramsTableBody.pageNumber,
        })

        this._notasParciales.buscarReporte(body).subscribe({
          next: (res: IListaReporteCalificacionesRes) => {
            if (res.error != null) {
              this.errorRutAlumno = res.error.mensaje
              this.limpiarMensajes()
            } else {
              this.listaReporteCalificaciones = res.listado
              this.checkReporteProgreso();
              callback({
                recordsTotal: res.totalItems,
                recordsFiltered: res.totalItems,
                data:[]
              })
              this._utilsFn.eliminarLoader('tabla-notas-parciales')
              if ( this.cargaInicial ) {
                this.spinner.hide()
                this.cargaInicial = false
              }

              this.ocultarTabla();
              this.ajustarTabla();
              
            }
          },
        })
      }
    }, 200);
    // Fin Datatable serverside
  }
checkReporteProgreso() {
  this.listaReporteCalificaciones.forEach((reporte:any) => {
    if(reporte.estadoProceso=='EP'){
      this.reporteEnProceso = true
    }
  });
}
ajustarTabla() {
  setTimeout(() => {
    $("#tabla-notas-parciales").DataTable().columns.adjust();
  }, 180);
}
ocultarTabla() {
  if ( this.listaReporteCalificaciones.length > 0 ) {
    setTimeout(() => {
      const emptyElement = document.querySelector('#tabla-notas-parciales_wrapper .dataTables_empty');
      emptyElement?.setAttribute('style', 'display: none');
    }, 50);
  }
}

  mostrarDetalleFiltros(i: number, docenteId: number, codigoAsignatura: string | null) {
    this.detalleFiltros = {}
    this.detalleFiltros = this.listaReporteCalificaciones[i]
    this._notasParciales.getFiltros(this.detalleFiltros?.periodoId, this.detalleFiltros?.sedeId, this.detalleFiltros?.docenteId).subscribe(
      (res:IObtenerFiltros) => {
        this.detalleFiltrosEsp = res
        this.detalleFiltrosEsp.codigoAsignatura = codigoAsignatura ?? null
        this.detalleFiltrosEsp.docente = docenteId == 0 ? null : docenteId;
        document.getElementById('btn-cantidadex')?.click()
      }
    )
  }

  generarReporte() {
    let error = false;
    this.renderTable = false;
    this.submitted = true;

    // this.obtenerReporteCalificaciones()
    if (typeof this.searchAsignaturaForm.value === 'object') {
      this.filtroAsignaturaSeleccionado = this.obtenerId(this.searchAsignaturaForm.value)
      this.asignaturaCodigo = this.obtenerAsignaturaCodigo(this.searchAsignaturaForm.value)
    } else {
      this.asignaturaCodigo = ''
      this.filtroAsignaturaSeleccionado = 0;
    }

    if (typeof this.searchIdDocenteForm.value === 'object') {
      this.filtroCodigoDocenteSeleccionado = this.obtenerCodigoDocente(this.searchIdDocenteForm.value)
    } else {
      this.filtroCodigoDocenteSeleccionado = "";
    }

    if (this.filtroAnhoSeleccionado == 0) {
      this.tieneErrores['anyo'] = true;
      error = true;
    }
    if (this.filtroPeriodoSeleccionado == 0) {
      this.tieneErrores["periodo"] = true;
      error = true;
    }

    if (this.rolUsuario === 2 && this.filtroSedeSeleccionado == 0) {
      this.tieneErrores["sede"] = true;
      error = true;
    }

    if (!error) {
      this.listaReporteCalificaciones = []
      // this.obtenerReporteCalificaciones()
      this.generarSolicitudReporte()
    }

  }

  mostrarReportes() {
    let error = false;
    this.renderTable = false
    this.submitted = true;

    // this.obtenerReporteCalificaciones()
    if (typeof this.searchAsignaturaForm.value === 'object') {
      this.filtroAsignaturaSeleccionado = this.obtenerId(this.searchAsignaturaForm.value)
      this.asignaturaCodigo = this.obtenerAsignaturaCodigo(this.searchAsignaturaForm.value)
    }
    if (typeof this.searchAsignaturaForm.value !== 'object' && this.searchAsignaturaForm.value != "") {
      this.tieneErrores['asignatura'] = true;
      error = true;
    }

    if (typeof this.searchIdDocenteForm.value === 'object') {
      this.filtroCodigoDocenteSeleccionado = this.obtenerCodigoDocente(this.searchIdDocenteForm.value)
    } else {
      this.filtroCodigoDocenteSeleccionado = "";
    }

    if (this.filtroAnhoSeleccionado == 0) {
      this.tieneErrores['anyo'] = true;
      error = true;
    }
    if (this.filtroPeriodoSeleccionado == 0) {
      this.tieneErrores["periodo"] = true;
      error = true;
    }
    if (this.rolUsuario === 2 && this.filtroSedeSeleccionado == 0) {
      this.tieneErrores["sede"] = true;
      error = true;
    }

    if (!error) {
      this.listaReporteCalificaciones = []
      this.buscarReporte()
    }

  }

  limpiarMensajes() {
    setTimeout(() => {
      this.error = '';
      this.mensajeExito = "";
      this.errorRutAlumno = ""
    }, 15000);
  }

  descargarArchivo(idSolicitud: number, fecha: string): void {
    this._notasParciales.getReporte(idSolicitud).subscribe(
      async (res: any) => {
        const contentDispositionHeader = res?.headers?.get('Content-Disposition')
        const fileName = contentDispositionHeader?.split(';')[1]?.trim()?.split('=')[1]
        const bufferPromise = await res?.body.arrayBuffer();
        const csvData = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), bufferPromise], {type: "text/plain;charset=utf-8"});
        saveAs(csvData, fileName?.replace(/"/g, '') ?? 'reporteCalificaciones.csv')
      }
    )
  }

  actualizarTabla(): void {
    this.funcionIntervalo = setInterval(() =>{
      if (document.visibilityState === 'visible' && this.reporteEnProceso) {
        this.mostrarReportes();
      }

    }, 20000);
  }
  ngOnDestroy(): void {
    clearInterval(this.funcionIntervalo);

  }

  limpiarFiltros() {
    this.listaAsignatura = []
    this.listaIdDocentes = []
    this.filtroAnhoSeleccionado = 0
    this.filtroPeriodoSeleccionado = 0
    this.searchAsignaturaForm.setValue("")
    this.filtroSedeSeleccionado = 0
    this.searchIdDocenteForm.setValue("")
    this.filtroPeriodos = []
    this.filtrosSede = []
    this.rut = ''
    this.renderTable = false

  }

  keypressNumber(event: any) {
    return this._utilsFn.keypressNumber(event)
  }

  validarRut(rut: string): boolean {
    if (rut == "") {
      this.errorRut = '<b class="font-size:13px;">El campo Rut no debe estar vacío</b>';
      setTimeout(() => {
        this.errorRut = "";
      }, 3000);
      return true;
    } else {
      if (!/^\d+[-|‐][0-9kK]$/.test(rut)) {
        this.errorRut = '<b class="font-size:13px;">Rut ingresado no es válido.</b>';
        setTimeout(() => {
          this.errorRut = "";
        }, 3000);
        return true;
      }
      let tmp = rut.split('-');
      let digv = tmp[1];
      rut = tmp[0];
      if (digv == 'K') digv = 'k';
      if (this.validarDigito(rut) != digv) {
        this.errorRut = '<b class="font-size:13px;">Rut ingresado no es válido.</b>';

        setTimeout(() => {
          this.errorRut = "";
        }, 3000);
        return true;
      }

    }
    return false;
  }

  validarDigito(T: any) {
    let M = 0, S = 1;
    for (; T; T = Math.floor(T / 10))
      S = (S + T % 10 * (9 - M++ % 6)) % 11;
    return S ? S - 1 : 'k';
  }
  setFormatoRut() {
    let valor: any = this.rut;
    if (valor.length > 1) {
      valor = valor.replace('-', '');
      valor = this.arreglarCP(valor, valor.length - 1);
    }
    this.rut = valor;
    this.resaltarError = this.validarRut(this.rut);
  }
  arreglarCP(addr: any, posicion: any) {
    return addr.slice(0, posicion) + "-" + (addr).slice(posicion);
  }
}
